import CircleCheck from './src/circle-check-combined';
export default CircleCheck;